export default __webpack_public_path__ + "static/media/480_dummy2016-personaltrainer01-de.ca659303.png";